import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserDataContext } from "../components/UserDataContext";
import VN from "../components/VN";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Row, Col, Container } from "react-bootstrap";
import { marginBottom } from "../App";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";

export default function Menu() {
  const navigate = useNavigate();
  const { userData } = useContext(UserDataContext);

  return (
    <div>
      <VN userData={userData} />
      <Container>
        <h1>MANAGER</h1>
      </Container>
    </div>
  );
}
